import React from "react";
import "./ProjectSingleDetails.css";
import MagneticCircleButton from "../Buttons/MagneticCircleButton/MagneticCircleButton";

const ProjectSingleDetails = ({projectDetails}) => {
  return (
    <div className="container project-single-details-container">
      {projectDetails.category && (
        <div className="project-single-details-wrapper">
          <ul>
            {projectDetails.category && (
              <li>
                <span>Catagory:</span>
                {projectDetails.category || "--"}
              </li>
            )}
            {projectDetails.client && (
              <li>
                <span>Clients:</span>
                {projectDetails.client || "--"}
              </li>
            )}
            {projectDetails.client && (
              <li>
                <span>Date:</span>
                {projectDetails.date || "--"}
              </li>
            )}
            {projectDetails.client && (
              <li>
                <span>Location:</span>
                {projectDetails.location || "--"}
              </li>
            )}
            {projectDetails.client && (
              <li>
                <span>Designer:</span>
                {projectDetails.designer || "--"}
              </li>
            )}
          </ul>
        </div>
      )}
      {projectDetails?.gridImages1?.length > 0 && (
        <div className="project-image-grid-1">
          <div className="image-grid-8">
            <img
              className="w-100"
              src={projectDetails.gridImages1[0]}
              alt={projectDetails.gridImages1[0]}
            />
          </div>
          <div className="image-grid-4">
            <img
              className="w-100"
              src={projectDetails.gridImages1[1]}
              alt={projectDetails.gridImages1[1]}
            />
          </div>
        </div>
      )}

      <div className="project-content">
        <div className="content-title">
          {projectDetails.overviewParagraph1 && <h3>project overview</h3>}
          <div className="project-link-button">
            <MagneticCircleButton
              text="Visit"
              text2="Website"
              to=""
              href={projectDetails.websiteLink}
              target="_blank"
            />
          </div>
        </div>
        {projectDetails.overviewParagraph1 && (
          <div className="content-details">
            <p>{projectDetails.overviewParagraph1}</p>
            <ul>
              {projectDetails.overviewChecks.map((checkPoints, index) => (
                <li key={index}>
                  <span>
                    <i className="ri-check-double-line"></i>
                    {checkPoints}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      {projectDetails?.gridImages2?.length > 0 && (
        <div className="project-image-grid-2">
          <div className="project-image-grid-full">
            <img
              src={projectDetails.gridImages2[0]}
              alt={projectDetails.gridImages2[0]}
            />
          </div>
          <div className="project-image-grid-half-half">
            <div className="half-grid">
              <img
                src={projectDetails.gridImages2[1]}
                alt={projectDetails.gridImages2[1]}
              />
            </div>
            <div className="half-grid">
              <img
                src={projectDetails.gridImages2[2]}
                alt={projectDetails.gridImages2[2]}
              />
            </div>
          </div>
        </div>
      )}
      {projectDetails.testingResultParagraphs?.length > 0 && (
        <div className="project-content">
          <div className="content-title">
            <h3>project testing and result</h3>
          </div>
          <div className="content-details">
            {projectDetails.testingResultParagraphs.map((paragraphs, index) => (
              <p key={index}>{paragraphs}</p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectSingleDetails;
